// src/utils/memberPhoneActions.js
// Actions de contact rapide sur un numéro de profil : WhatsApp, appel, SMS,
// copie. UNE seule fonction décide de tout, pour que les quatre boutons
// partagent exactement les mêmes gardes.
//
// Gardes (toutes obligatoires, sinon AUCUNE action, valeur incluse) :
//  - contact autorisé : même règle que « Envoyer un message » ;
//  - champ non masqué : `privacy_settings[field] === false`. NÉCESSAIRE côté
//    front : le back (filterMemberByPrivacy) renvoie tous les champs à un admin,
//    numéros masqués compris. Seul ce test empêche de proposer un contact que le
//    membre a choisi de ne pas partager.
import { toWhatsAppNumber, getMemberWhatsAppUrl } from './whatsapp'

const NO_ACTIONS = { whatsappUrl: null, telUrl: null, smsUrl: null, copyValue: null }

/**
 * @returns {{whatsappUrl, telUrl, smsUrl, copyValue}} Chaque entrée est null
 * si l'action ne doit pas être proposée.
 *  - telUrl : mobile ET fixe, dès que le numéro est normalisable (un fixe n'a
 *    pas de WhatsApp mais peut s'appeler).
 *  - smsUrl : mobile uniquement (un fixe ne reçoit pas de SMS).
 *  - whatsappUrl : cf. getMemberWhatsAppUrl (mobile ; fixe seulement si
 *    explicitement international).
 *  - copyValue : numéro normalisé `+…` si possible, sinon la saisie brute (on
 *    peut toujours copier ce qu'on affiche déjà).
 */
export function getMemberPhoneActions({ member, field, canContact }) {
  if (!canContact || !member) return NO_ACTIONS
  if (member.privacy_settings?.[field] === false) return NO_ACTIONS
  const raw = member[field]
  if (typeof raw !== 'string' || !raw.trim()) return NO_ACTIONS

  const number = toWhatsAppNumber(raw, member.country)
  return {
    whatsappUrl: getMemberWhatsAppUrl({ member, field, canContact }),
    telUrl: number ? `tel:+${number}` : null,
    smsUrl: number && field === 'mobilePhone' ? `sms:+${number}` : null,
    copyValue: number ? `+${number}` : raw.trim(),
  }
}
